<div class="page_wrapper">
    <div class="full_bg">
        <section class="signup_section">
            <div class="container">

                <div class="top_part">
                    <a (click)="goToHome()" class="back_btn" style="cursor: pointer;">
                        <i class="fa fa-arrow-left"></i> Back to home
                    </a>
                    <a class="navbar-brand" (click)="goToHome()" style="cursor: pointer;">
                        <img src="assets/images/auth/logo.png" alt="ShiftClock Logo">
                    </a>
                </div>

                <div class="form_block">

                    <div class="side_screen">
                        <div class="section_title">
                            <h2>Verify Your OTP</h2>
                            <p>Enter the one-time password sent to your email to proceed with password reset.</p>
                        </div>
                    </div>

                    <div class="form_side">
                        
                        <!-- Success State with Green Tick -->
                        <div *ngIf="isSuccessState" class="success-state-container">
                            <div class="success-check-wrapper">
                                <div class="success-check-icon">
                                    <svg viewBox="0 0 52 52" class="checkmark">
                                        <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                                        <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                    </svg>
                                </div>
                                <h3 class="success-title">Verification Successful!</h3>
                                <p class="success-message">{{ successMessage }}</p>
                                <div class="btn_block">
                                    <button type="button" class="puprple_btn" (click)="goToSignUp()">
                                        Go to Sign Up
                                    </button>
                                    <div class="btn_bottom"></div>
                                </div>
                            </div>
                        </div>

                        <!-- OTP Form (Hidden when success state is active) -->
                        <div *ngIf="!isSuccessState">
                            <div class="section_title">
                                <span class="title_badge">OTP Verification</span>
                                <h4>Enter OTP</h4>
                                <p>Check your email and type the code below to verify your identity.</p>
                            </div>

                            <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">

                                <div class="form-group">
                                    <input type="text" formControlName="otp" class="form-control" placeholder="Enter 6-digit OTP" maxlength="6" [class.is-invalid]="f['otp'].invalid && f['otp'].touched">
                                </div>

                                <div class="btn_block">
                                    <button type="submit" class="puprple_btn" [disabled]="isLoading">
                      {{ isLoading ? 'Verifying...' : 'Verify OTP' }}
                    </button>
                                    <div class="btn_bottom"></div>
                                </div>

                                <div class="sign_in_here mt-3">
                                    <p>Didn't receive OTP? <a (click)="resendOTP()" style="cursor: pointer;">Resend OTP</a></p>
                                </div>

                                <div *ngIf="successMessage && !isSuccessState" class="message mt-2" style="display: block;">
                                    {{ successMessage }}
                                </div>

                                <div *ngIf="errorMessage" class="error text-danger mt-2">
                                    {{ errorMessage }}
                                </div>

                            </form>
                        </div>

                    </div>

                </div>

            </div>
        </section>
    </div>
</div>